import Link from "next/link";
import SectionHeader from "@/components/SectionHeader";
import { TruckIcon, WrenchScrewdriverIcon } from "@heroicons/react/24/outline";

/**
 * Die Grundentscheidung, die vor allen anderen steht — und die Frage, die
 * das Angebot dieser Seite überhaupt erst erklärt.
 *
 * Bewusst ohne Preise: Die stehen einen Abschnitt weiter oben. Hier geht es
 * um den praktischen Unterschied, den man vorher selten kennt.
 */

const ZEILEN = [
  {
    kriterium: "Aufbau",
    versand: "Du selbst, in 10 bis 15 Minuten",
    vorOrt: "Der Anbieter, vor der Feier",
  },
  {
    kriterium: "Wann sie da ist",
    versand: "Ein bis fünf Tage vorher per Paket",
    vorOrt: "Am Tag der Feier oder am Vortag",
  },
  {
    kriterium: "Rückgabe",
    versand: "Zurück ins Paket, Retourenschein liegt bei",
    vorOrt: "Der Anbieter holt sie wieder ab",
  },
  {
    kriterium: "Wenn etwas klemmt",
    versand: "Telefon-Hotline des Anbieters",
    vorOrt: "Ansprechpartner in der Nähe, teils vor Ort",
  },
  {
    kriterium: "Gut geeignet für",
    versand: "Private Feiern, Hochzeiten, Geburtstage",
    vorOrt: "Große Events, Firmenfeiern, enge Zeitpläne",
  },
];

export default function LieferwegSektion({ anzahlVersand, anzahlVorOrt }) {
  return (
    <SectionHeader
      id="lieferweg"
      title="Versand-Fotobox oder Anbieter vor Ort?"
      subtitle="Die Entscheidung, die alles andere vorgibt — und der Unterschied, den man vorher selten kennt."
    >
      <div className="mx-auto mt-8 max-w-3xl text-left text-[15px] leading-7 text-slate-700">
        <p>
          Beide Wege führen zur selben Fotobox auf eurer Feier. Sie
          unterscheiden sich darin, wer sie aufbaut und wie viel Zeit ihr am
          Eventtag dafür einplanen müsst. Im Vergleich stehen{" "}
          <strong className="font-semibold text-slate-900">
            {anzahlVersand} Versand-Fotoboxen
          </strong>{" "}
          und{" "}
          <strong className="font-semibold text-slate-900">
            {anzahlVorOrt} Anbieter vor Ort
          </strong>
          .
        </p>

        <div className="mt-6 overflow-x-auto">
          <table className="w-full min-w-[520px] border-collapse text-left text-sm">
            <thead>
              <tr className="border-b border-slate-200 text-xs uppercase tracking-wider text-slate-500">
                <th scope="col" className="py-2 pr-4 font-semibold">
                  &nbsp;
                </th>
                <th scope="col" className="py-2 pr-4 font-semibold">
                  <span className="inline-flex items-center gap-1.5">
                    <TruckIcon className="h-4 w-4" aria-hidden="true" />
                    Versand
                  </span>
                </th>
                <th scope="col" className="py-2 font-semibold">
                  <span className="inline-flex items-center gap-1.5">
                    <WrenchScrewdriverIcon
                      className="h-4 w-4"
                      aria-hidden="true"
                    />
                    Vor Ort
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {ZEILEN.map((z) => (
                <tr
                  key={z.kriterium}
                  className="border-b border-slate-100 align-top last:border-0"
                >
                  <th
                    scope="row"
                    className="py-2.5 pr-4 font-medium text-slate-900"
                  >
                    {z.kriterium}
                  </th>
                  <td className="py-2.5 pr-4 text-slate-600">{z.versand}</td>
                  <td className="py-2.5 text-slate-600">{z.vorOrt}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="mt-6">
          Für die meisten privaten Feiern reicht die Versandbox: Sie ist
          günstiger, kommt ein paar Tage vorher an, und der Aufbau ist mit
          Stativ und Anleitung in einer Viertelstunde erledigt. Ein Anbieter vor
          Ort lohnt sich, wenn am Eventtag niemand Zeit für Technik hat, wenn
          die Location früh geschlossen wird oder wenn viele Gäste in kurzer
          Zeit durch die Box sollen — dann ist jemand da, der sie im Blick hat.
        </p>
        <p className="mt-4">
          <Link
            href="/fotobox-mieten-in-der-naehe"
            className="font-semibold text-[#FF5744] underline-offset-2 hover:underline"
          >
            Anbieter in deiner Nähe finden
          </Link>
        </p>
      </div>
    </SectionHeader>
  );
}
